import React from 'react';

export default (BaseComponent) => {
  const displayName =
    BaseComponent.displayName || BaseComponent.name || 'Component';

  class withViewBeacon extends React.PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        beacons: []
      };

      this.handleProductIntersection = this.handleProductIntersection.bind(this);
    }

    handleProductIntersection(productProps, isIntersecting, intersectionRatio, unobserve) {
      if (!isIntersecting || intersectionRatio < 0.5) {
        return;
      }
      unobserve();
      const viewBeaconUrl = (
        productProps &&
        productProps.beacons &&
        productProps.beacons.onView
      )
        ? productProps.beacons.onView
        : undefined;
      if (viewBeaconUrl) {
        const viewBeacon = {
          id: productProps.id,
          url: viewBeaconUrl
        };

        this.setState(state => ({
          beacons: [...state.beacons, viewBeacon]
        }));
      }
    }

    render() {
      return (
        <React.Fragment>
          <BaseComponent
            {...this.props}
            onProductIntersection={this.handleProductIntersection}
          />
          {this.state.beacons.length &&
          <div className="sponsored-products-beacon-wrapper beacon-wrapper">
            {this.state.beacons.map(
              beacon =>
                <img key={beacon.id} src={beacon.url} alt="beacon" />
            )}
          </div>
          }
        </React.Fragment>
      );
    }
  }

  withViewBeacon.displayName =
    `withViewBeacon(${displayName})`;

  withViewBeacon.propTypes = {};

  return withViewBeacon;
};
